import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const LoginViewBox = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  minWidth: '100vw',
  justifyContent: 'center',
  backgroundColor: theme.palette.primary.main,
}));

export const ProfileSubHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.black,
  fontWeight: 700,
  fontSize: '32px',
  lineHeight: '32px',
  paddingBottom: '16px',
}));
